module.exports = __webpack_public_path__ + "img/design.ec1427a3.png";